module.exports = __webpack_public_path__ + "static/media/mediagate.4726c16b.png";